import { ref, computed } from '@vue/composition-api'
import { THEME_MODE, THEME_TYPE, APP_THEME_TO_THEME_INFO_MAP } from '../config/theme'
import { appInfo, isApp } from 'wap/hybrid/device.js'

export const isCurrentPageEnabledTheme = ref(false)

export const themeModeValueToNameMap = computed(() => {
  const themeModeValueToNameMap = new Map()
  Object.values(THEME_MODE).forEach((item) => {
    themeModeValueToNameMap.set(item.value, item.name)
  })
  return themeModeValueToNameMap
})

export const themeTypeValueToNameMap = computed(() => {
  const themeTypeValueToNameMap = new Map()
  Object.values(THEME_TYPE).forEach((item) => {
    themeTypeValueToNameMap.set(item.value, item.name)
  })
  return themeTypeValueToNameMap
})

export const isThemeModeExists = (value) => {
  return themeModeValueToNameMap.value.has(Number(value))
}

export const isThemeTypeExists = (value) => {
  return themeTypeValueToNameMap.value.has(Number(value))
}

export const getThemeMode = () => {
  const mode = isApp() 
    ? getAppThemeInfo().mode.value
    : localStorage.getItem('themeMode')
  if (mode && isThemeModeExists(mode)) {
    return Number(mode)
  }

  return THEME_MODE.DARK.value
}

export const getSystemThemeMode = () => {
  const systemThemeMode = isApp() 
  ? null
  : localStorage.getItem('systemThemeMode')

  if (systemThemeMode && isThemeModeExists(systemThemeMode)) {
    return Number(systemThemeMode)
  }

  return null
}

export const getThemeType = () => {
  const type = isApp() 
    ? getAppThemeInfo().type.value
    : localStorage.getItem('themeType')

  if (type && isThemeTypeExists(type)) {
    return Number(type)
  }

  return THEME_TYPE.DEFAULT.value
}

export const getBrowserThemeMode = () => {
  if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
    return THEME_MODE.DARK.value
  }

  return THEME_MODE.LIGHT.value
}

export const getAppThemeInfo = () => {
  /** @type {1 | 2 | 3 | 4 | 5 | 6} */
  const appTheme = appInfo.theme
  const themeInfo = APP_THEME_TO_THEME_INFO_MAP[appTheme] ?? APP_THEME_TO_THEME_INFO_MAP[1]
  return themeInfo
}
